class ShopAppointmentReasonsCtrl {

    constructor($scope, storeServ) {

        this.$scope = $scope;
        this.storeServ = storeServ;

        this.subscribeToStore();

        this.addComponentDestroyListener();
    }

    /**
     *  Init.
     */

    subscribeToStore() {
        this.unsubscribeFromStore = this.storeServ.subscribe(this.onStateChange.bind(this));
    }

    addComponentDestroyListener() {
        this.$scope.$on('$destroy', this.onDestroyComponent.bind(this));
    }

    /**
     *  Listeners.
     */

    onStateChange() {
        this.reasons = this.storeServ.getState().shopAppointmentReasons;
    }

    onDestroyComponent() {
        this.unsubscribeFromStore();
    }
}

ShopAppointmentReasonsCtrl.$inject = ['$scope', 'storeServ'];

var shopAppointmentReasons = function() {
    return {
        restrict: 'E',
        scope: {},
        controller: ShopAppointmentReasonsCtrl,
        controllerAs: 'shopAppointmentReasonsCtrl',
        bindToController: {
            reasons: '='
        }
    };
};

export default shopAppointmentReasons;
